<template>
  <div class="container">
    <T1Breadcrumbs class="mb-24" :homeLink="true" :items="getBreadcrumbs()" />
    <h2 class="font-24 font-m mb-24">{{ getSectionTitle() }}</h2>
    <template v-if="getLayoutType() == 'grid'">
      <div class="category-tabs mb-48">
        <T1GTabs tabLabelType="h3">
          <template v-for="(tab, idx) in serviceConfig.groupsTitles">
            <T1GTabsContent
              :key="idx"
              :title="getTitle(idx)"
              :renderContent="idx === 0 ? true : false"
            >
              <T1OffersCategoryGroupGrid
                :nntab="getTitle(idx)"
                :url="serviceConfig.url"
                :pricesUrl="serviceConfig.pricesUrl"
              />
            </T1GTabsContent>
          </template>
        </T1GTabs>
      </div>
    </template>
    <template v-if="getLayoutType() == 'rows'">
      <T1OffersCategoryGroupRows :options="serviceConfig" />
    </template>
  </div>
</template>

<script>
import { offerCategoryConfig } from "./offerCategoryConfig.js";
import T1Breadcrumbs from "./T1Breadcrumbs/T1Breadcrumbs";
import T1GTabs from "./T1Tabs/T1GTabs";
import T1GTabsContent from "./T1Tabs/T1GTabsContent";
import T1OffersCategoryGroupGrid from "./T1OffersCategoryGroupGrid";
import T1OffersCategoryGroupRows from "./T1OffersCategoryGroupRows";

export default {
  name: "offers-category-content",
  components: {
    T1Breadcrumbs,
    T1GTabs,
    T1GTabsContent,
    T1OffersCategoryGroupGrid,
    T1OffersCategoryGroupRows,
  },
  data: () => ({
    serviceConfig: offerCategoryConfig.options[0],
  }),
  methods: {
    getBreadcrumbs() {
      let crumbsArr = [];
      crumbsArr.push(
        { name: "Travelone.pl", link: "https://www.travelone.pl/" },
        { name: this.serviceConfig.categoryName, link: "/" }
      );
      return crumbsArr;
    },
    getSectionTitle() {
      return this.serviceConfig.headingTitle;
    },
    getTitle(i) {
      return this.serviceConfig.groupsTitles[i];
    },
    getLayoutType() {
      return this.serviceConfig.layoutStyle;
    },
  },
};
</script>

<style lang="scss" scoped>
.category-tabs {
  ::v-deep.tabs {
    border-bottom: 0;
  }
}
</style>
